import { AppRoutes } from "../../lib/common/AppRoutes";

export default function Software() {
  return (
    <div className="prose">
      <h1 className="hero__title">{AppRoutes.SOFTWARE.title}</h1>
      <p>
        Coming Soon.
      </p>
    </div>
  );
}
